<template>
  <div id="app">
    <router-view />
    <van-tabbar v-show="showTabbar" v-model="active" style="height: 50px;z-index: 99999999999;" active-color="#00aa30" safe-area-inset-bottom>
      <van-tabbar-item
        icon="customiz iconfont icon-dingwei1"
        :class="{ active: '/home' == $route.path }"
        @click="$router.push({ name: 'home' })"
        >定位</van-tabbar-item
      >
      <van-tabbar-item icon="chat-o" :dot="messageState" @click="$router.push({ name: 'message' })"
        >消息</van-tabbar-item
      >
      <van-tabbar-item icon="c iconfont icon-kaoqin" @click="$router.push({ name: 'attendance' })"
        >考勤</van-tabbar-item
      >
      <van-tabbar-item icon="setting-o" @click="$router.push({ name: 'my' })">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
import { Tabbar, TabbarItem } from 'vant'

export default {
  data() {
    return {
      messageState: false, // 展示小红点
      active: 0,
      showTabbar: false,
      footerHeight: '0'
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        if (
          to.name === 'home' ||
          to.name === 'message' ||
          to.name === 'attendance' ||
          to.name === 'my'
        ) {
          this.showTabbar = true
        } else {
          this.showTabbar = false
        }
        if (to.name === 'home') {
          this.active = 0
        } else if (to.name === 'message') {
          this.active = 1
        } else if (to.name === 'attendance') {
          this.active = 2
        } else if (to.name === 'my') {
          this.active = 3
        }
        if (to.name && to.name !== 'login' && to.name !== 'recharge') {
          //this.getMessageState()
        }
      },
      immediate: true
    }
  },
  methods: {
    getMessageState() {
      this.$http
        .json_post(this.$api.message.messageState, {
          student_id: localStorage.getItem('studentId')
        })
        .then(data => {
          if (data.code == 200) {
            data.result > 0 ? (this.messageState = true) : (this.messageState = false)
          }
        })
    }
  },
  components: {
    'van-tabbar': Tabbar,
    'van-tabbar-item': TabbarItem
  }
}
</script>

<style scoped>
#app {
  font-size: 14px;
  color: #323233;
  background-color: #f7f8fa;
}
</style>
